import Link from 'next/link'
import { FastlyImage } from '@components/common/image'
import { t, Trans } from '@lingui/macro'
import { Quote } from '@components/common/icons/custom-icons'
import Button from '@components/atoms/button'

type FounderCardProps = {
  name: string
  title: string
  bio: string
  quote: string
  path: string
  imageName: string
  alumni: string
  linkedin: string
}

const FounderCard = ({
  name,
  title,
  bio,
  quote,
  path,
  imageName,
  alumni,
}: FounderCardProps) => (
  <div className="relative flex flex-col bg-white rounded-lg max-w-sm px-4 lg:px-8 py-8 lg:py-12 text-center items-center z-10 shadow-2xl justify-between">
    <p className="text-grey font-600">&ldquo;{quote}&rdquo;</p>
    <FastlyImage
      src={`${path}${imageName}.png`}
      webpSrc={`${path}${imageName}.webp`}
      width={161}
      height={154}
      alt={name}
    />
    <div>
      <p className="text-grey font-700 text-xl">{name}</p>
      <p className="text-grey">{title}</p>
      <p className="text-grey">{alumni}</p>
      <p className="text-grey mt-2" style={{ minHeight: '72px' }}>
        {bio}
      </p>
    </div>
  </div>
)

const Founders = () => (
  <div
    style={{
      background: `url('/images/home/founders/box-bg.png') repeat-x`,
    }}
  >
    <div className="container mx-auto flex flex-col relative items-center py-12 lg:py-16 px-5 overflow-x-hidden">
      <h2 className="relative text-grey font-600 text-2xl max-w-2xl mx-6 text-center leading-tight lg:text-4xl mb-5">
        <Quote className="text-orange absolute left-0 -mt-2 -ml-6 h-3 lg:h-6" />
        &ldquo;
        <Trans id="homepage.foundersFold.heading">
          Our passion for coding and AI drives us to teach, inspiring kids to
          unlock their potential and shape the future
        </Trans>
        &rdquo;
      </h2>

      <div className="mt-5 mb-16 flex flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-5 relative">
        <FounderCard
          name={t`Vivek Prakash`}
          title={t`Co-founder & CEO, Codingal`}
          bio={t`Also, Co-Founder of HackerEarth - one of the largest developer community globally`}
          alumni={t`IIT Roorkee`}
          quote={t`Teaching coding and AI to kids is a profound responsibility. Our dedicated educators and meticulously crafted curriculum reflect our deep understanding and commitment to nurturing future innovators.`}
          path="/images/home/founders/"
          imageName="vivek-v1"
          linkedin="https://www.linkedin.com/in/prakashvivek/"
        />
        <FounderCard
          name={t`Satyam Baranwal`}
          title={t`Co-founder & COO, Codingal`}
          bio={t`Previously founded Skillovate - an initiative to impart coding & robotics workshops to children`}
          alumni={t`IIT Dhanbad`}
          quote={t`Learning to code is not just about reaching new heights like going to Mars or the moon. Coding, along with AI, equips kids with the skills to think critically and creatively, empowering them at multiple levels.`}
          path="/images/home/founders/"
          imageName="satyam-v1"
          linkedin="https://www.linkedin.com/in/satyam-baranwal/"
        />
      </div>
      <Link href="/about-us" prefetch={false}>
        <div className="lg:self-start w-full lg:w-auto mx-auto">
          <Button variant="solid" size="xl" className="w-full lg:w-auto">
            <Trans id="homepage.foundersFold.cta">Meet the team</Trans>
          </Button>
        </div>
      </Link>
    </div>
  </div>
)

export default Founders
